module.exports = __webpack_public_path__ + "img/tsc-logo-icon.a2f02f22.png";